import validate from '@/utils/validations/cpf'

export default {
    validate,
    message: 'O CPF informado é inválido.',
}